import { render } from "./UserExpiringNote.vue?vue&type=template&id=7daf1261&scoped=true"
import script from "./UserExpiringNote.vue?vue&type=script&lang=js"
export * from "./UserExpiringNote.vue?vue&type=script&lang=js"

import "./UserExpiringNote.vue?vue&type=style&index=0&id=7daf1261&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7daf1261"]])

export default __exports__